import { ADMIN_USER_TYPE_KEY } from "@/core/constants";
import { useAuthStoreShallow } from "@/features/authentication";
import { Icon, setCookie } from "@/shared";
import Popover from "@components/ui/popover";
import type { ISelectOption } from "@components/ui/select";
import { cn } from "@lib/cn";

const OPTIONS = [
  {
    label: "User",
    value: "user",
  },
  {
    label: "Creator lite",
    value: "creator lite",
  },
  {
    label: "Creator",
    value: "creator",
  },
  {
    label: "Administrator",
    value: "administrator",
  },
  {
    label: "Storydoc Admin",
    value: "storydoc admin",
  },
];

export const UserMenuAdminTypeSelect = () => {
  const userType = useAuthStoreShallow((s) => s.userType);
  const handleSelect = (option: ISelectOption) => {
    setCookie({ name: ADMIN_USER_TYPE_KEY, value: option.value, days: 365 });
    localStorage.setItem(ADMIN_USER_TYPE_KEY, option.value);
    window.location.reload();
  };

  const selectedOption = OPTIONS.find((option) => option.value === userType);

  return (
    <Popover placement="bottom-end">
      <Popover.Trigger className="tw-cursor-pointer tw-mb-1">
        <div className="tw-flex tw-items-center tw-justify-between tw-h-9 tw-mt-1 tw-rounded-lg tw-outline tw-outline-blue/5 tw-outline-1 tw-bg-white tw-px-3 tw-text-[13px] tw-font-normal tw-text-blue">
          {selectedOption?.label}
          <Icon icon="ri-expand-up-down-line" className="tw-text-blue-600" />
        </div>
      </Popover.Trigger>
      <Popover.Content className="tw-w-[180px] tw-z-[99999]">
        <div className="tw-space-y-0.5 tw-rounded-lg tw-bg-white tw-p-1 tw-shadow-xs tw-outline tw-outline-blue/5 tw-outline-1">
          {OPTIONS.map((option) => (
            <button
              type="button"
              onClick={() => handleSelect(option)}
              key={option.value}
              className={cn(
                "tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-gap-2 tw-w-full tw-rounded tw-p-2 tw-text-sm tw-font-normal tw-text-blue tw-transition-colors hover:tw-bg-blue-50",
                userType === option.value &&
                  "tw-bg-primary-50 tw-text-primary hover:tw-bg-primary-50",
              )}
            >
              {option.label}
            </button>
          ))}
        </div>
      </Popover.Content>
    </Popover>
  );
};
